import {
  ClientTrackRequest,
  ClientTrackResponse,
  FormDetailResponse,
  ReActivateRequest,
  RequestTrackTimeLineResponse,
  SaveFormDataRequest,
  SaveFormDataResponse,
} from "@models/ClientTrackModels";
import api from "./axiosInstance";
import { ApiBaseResponse } from "models/ApiBaseResponse";

// Departman fonksiyonları
const ClientTrackApi = {
  getClientTrack: async (trackUrl: string): Promise<ClientTrackResponse | null> => {
    try {
      const response = await api.get<{ content: ClientTrackResponse }>(`/ClientTrack?trackAppUrl=${trackUrl}`);
      return response.data.content;
    } catch (error) {
      console.error(`Error getAllRequestsByRequestType:`, error);
      return null;
    }
  },
  createClientTrack: async (data: ClientTrackRequest): Promise<ApiBaseResponse<null> | null> => {
    try {
      const response = await api.post<ApiBaseResponse<null>>(`/ClientTrack`, data);
      return response.data;
    } catch (error) {
      console.error(`Error getAllRequestsByRequestType:`, error);
      return null;
    }
  },
  getRequestTrackTimeLine: async (
    requestId: number,
    requestToken: string
  ): Promise<RequestTrackTimeLineResponse | null> => {
    try {
      const response = await api.get<{ content: RequestTrackTimeLineResponse }>(
        `/ClientTrack/RequestTrackTimeLine?requestId=${requestId}&requestToken=${requestToken}`
      );
      return response.data.content;
    } catch (error) {
      console.error(`Error getAllRequestsByRequestType:`, error);
      return null;
    }
  },
  setReActivateRequest: async (
    requestId: number,
    requestToken: string,
    data: ReActivateRequest
  ): Promise<ApiBaseResponse<null> | null> => {
    try {
      const response = await api.post<ApiBaseResponse<null>>(
        `/ClientTrack/ReActivateRequest?requestId=${requestId}&requestToken=${requestToken}`,
        data
      );
      return response.data;
    } catch (error) {
      console.error(`Error getAllRequestsByRequestType:`, error);
      return null;
    }
  },
  getFormDetail: async (formId: number, formToken: string): Promise<ApiBaseResponse<FormDetailResponse> | null> => {
    try {
      const response = await api.get<ApiBaseResponse<FormDetailResponse>>(
        `/ClientTrack/FormDetail?formId=${formId}&formToken=${formToken}`
      );
      return response.data;
    } catch (error) {
      console.error(`Error getFormDetail:`, error);
      return null;
    }
  },
  saveFormData: async (
    formId: number,
    formToken: string,
    data: SaveFormDataRequest
  ): Promise<ApiBaseResponse<SaveFormDataResponse> | null> => {
    try {
      const response = await api.post<ApiBaseResponse<SaveFormDataResponse>>(
        `/ClientTrack/SaveFormData?formId=${formId}&formToken=${formToken}`,
        data
      );
      return response.data;
    } catch (error) {
      console.error(`Error saveFormData:`, error);
      return null;
    }
  },
};

export default ClientTrackApi;
